export const cartActionTypes = {
  SAVE_CART: "SAVE_CART",
  SEARCH_FARE: "SEARCH_FARE",
  LOADER: "LOADER",
  ANCILLARY_STEP: "ANCILLARY_TYPE",
  SEAT_DATA: "SEAT_DATA",
  ANCILLARY_DATA: "ANCILLARY_DATA",
};
